import img1 from '/static/img/experience/accommodations/img1.png'
import img2 from '/static/img/experience/accommodations/img2.png'
import img3 from '/static/img/experience/accommodations/img3.png'
import img4 from '/static/img/experience/accommodations/img4.png'
const accommodationsList = [
    {
        id: 1,
        lable: 'City Accommodation',
        title: 'City Center Hotel',
        desc: 'We book high-end hotels in the city center with easy access to cultural landmarks and fine dining. Balancing luxury with convenient geography, they come in a variety of styles and offer personalized service and a wide range of amenities.',
        img:img1,
    },
    {
        id: 2,
        lable: 'Outdoor Vacation',
        title: 'resorts',
        desc: 'At wilderness resorts or beaches, etc., these hotels offer luxury accommodations that allow you to immerse yourself in natural beauty and also have a top-notch lodging experience with full-service amenities.',
        img:img2,
    },
    {
        id: 3,
        lable: 'tent camping',
        title: 'Luxury Camping Tent',
        desc: 'Glamping tents are renowned for their immersive viewing experience, often in the most scenic locations, where you can fall asleep to the sounds of nature without compromising on comfort, and you still get the best facilities and first class service!',
        img:img3,
    },
    {
        id: 4,
        lable: 'Outdoor Vacation',
        title: 'Opulent Former palaces',
        desc: 'These historic royal palaces have been converted into hotels with designs and architecture that give different meanings. Each luxury palace hotel has a unique identity with a distinctive luxury experience and service sensation.',
        img:img4,
    },
]
export default {
    accommodationsList
};